import {
	type FailoverAlertDto,
	type FailoverAlertReason,
	type FailoverStatusDto,
	failoverBlockedReason,
} from "@/types/ai-assistant-failover";
import type { ProviderMode } from "@/types/ai-assistant-provider-mode";

const ALERT_TEXT: Record<FailoverAlertReason, string> = {
	quota_exhausted: "kuota/saldo habis",
	auth_rejected: "kunci ditolak vendor",
};

const SLOT_LABEL: Record<string, string> = {
	chat: "Chat (Claude)",
	chat_backup: "Chat cadangan (OpenAI)",
};

/** Alasan sakelar belum bisa dinyalakan untuk mode ini (null = boleh). Sama dengan pesan penolakan server. */
export function failoverSwitchBlocked(
	status: FailoverStatusDto,
	mode: ProviderMode,
	cryptoConfigured: boolean,
): string | null {
	return failoverBlockedReason(status, mode, cryptoConfigured);
}

/** Satu baris per peringatan: profil, alasan, waktu (lokal). */
export function alertLines(alerts: FailoverAlertDto[]): string[] {
	return alerts.map(
		(a) =>
			`${SLOT_LABEL[a.slot] ?? a.slot}: ${ALERT_TEXT[a.reason]} — ${new Date(a.at).toLocaleString("id-ID")}`,
	);
}
